import { Type, Injectable } from '@angular/core';
import { WachterUserExt } from '../models/wachter-user.model';
import { AppMetaDataItemNames, AppMetaDataService } from '../../meta-data/app-meta-data.service';
// tslint:disable-next-line: max-line-length
import { DwContextDefinition, DwCustomContextBase, DwCustomContextDefinition, DwQuery, DwQueryHelper, DwSecurityTopics, DwSecurityUserService } from '@devwareapps/devware-cap';
import { DwQueryRelation, DwField } from '@devwareapps/devware-cap';


export const ethosUserContext = 'ethosUserContext'
@DwCustomContextDefinition({
    keyName: ethosUserContext,
    display: 'Current Ethos User',
    isGlobal: true,
    item: AppMetaDataItemNames.EthosUser,
})
@Injectable()
export class CurrentEthosUserContextDefService extends DwCustomContextBase {

    constructor(private dwSecurityUserService: DwSecurityUserService) {
        super();
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.buildQueryFunction = (context) => this.buildQuery(context);

        contextDef.cacheInvalidationTopics = [DwSecurityTopics.SECURITY_CHANGED];
    }

    buildQuery(resolvedContext: any): DwQuery {
        const query = new DwQuery(AppMetaDataItemNames.EthosUser);

        const wmd = new AppMetaDataService();
        const qh = new DwQueryHelper();

        const user = this.dwSecurityUserService.securityContext?.ApplicationUser;

        if (!user) {
            return null;
        }

        let ethosUserId = -1;

        if (user) {
            const wachterUser = new WachterUserExt(user);

            ethosUserId = wachterUser.trustUserId;
        }

        if (!ethosUserId) {
            ethosUserId = -1;
        }

        // Add related table field (it will match the closed relationship to get to this table - an error will occur if the relation is not found - or exceeds the configured max depth)        
        query.AddField(wmd.EthosWachterDepartment.WachterDivisionId);
        
        // Include all main fields
        query.FieldSettings.IncludeRootItemFields = true;

        query.AddFilterAnd(qh.filters.Equal(wmd.EthosUser.UserId, ethosUserId));

        const deptRelation = new DwQueryRelation();
        deptRelation.RelationName = wmd.EthosUser.Relations.EthosWachterDepartment.RelationName;

        const dwField = new DwField();
        dwField.FullFieldName = wmd.EthosWachterDepartment.WachterDivisionId; 
        deptRelation.RelationFields.push(dwField); 

        query.AddRelation(deptRelation);
        return query;
    }
}
